<template>
  <div class="main">
    <ul>
      <li class="blogItem" v-for="item in noteList">
        <h2 class="blogTitle">{{item.caption}}</h2>
        <span class="blogUpTime">{{item.updatetime}}</span>
        <p class="blogIntro">{{item.intro}}</p>
        <a class="blogDetail" @click="$goRoute('noteItem',{noteData:item})">阅读全文»</a>
        <!--<a class="blogDetail" target="_blank" :href="item.url">阅读全文»</a>-->
      </li>
    </ul>
    <div class="pageCon">
      <el-pagination
        background
        @current-change="changePage"
        :current-page="this.page"
        :page-size="this.pageCount"
        layout="total, prev, pager, next, jumper"
        :total="this.noteTotal.length">
      </el-pagination>
    </div>
    <!--<a @click="$goRoute('/noteItem')">详情</a>-->
  </div>
</template>

<script>
  export default {
    name: 'home',
    data() {
      return {
        home: '这是主页',
        // noteAllData:this.$store.state.noteList.notes,
        page:1,
        pageCount:10
      }
    },
    // beforeCreate:function () {
    //
    //   this.noteAllData=this.$store.state.noteList.notes
    //   console.log(1)
    // },
    // updated:function(){
    //   this.noteAllData=this.$store.state.noteList.notes
    //
    // },
    computed: {
      // noteAllData() {
      //   return this.$store.state.noteList.notes
      // },
      noteList: function () {
          // console.log(2,this.noteData);
          let ary = [];
          if (this.$store.state.noteList.notes){
            for (var i = (this.page - 1) * this.pageCount; i <= this.page * this.pageCount - 1; i++) {
              if (this.$store.state.noteList.notes[i]) {
                ary.push(this.$store.state.noteList.notes[i])
              }
            }
          }
          return ary
      },
      noteTotal:function () {
        return this.$store.state.noteList.notes||[]
      }
      // _that.noteList = _that.$store.state.noteList.notes;
    },
    methods: {
      changePage: function (v) {
        console.log('当前页码：'+v);
        this.page=v
      }
    },
    mounted:function () {
      // console.log(1);
      window.document.title='首页 - 小桃酥的曲奇饼';
    }

  }
</script>

<style lang="scss">
  .main {
    padding-right: 20px;
    padding-top: 20px;
    .blogItem {
      position: relative;
      margin: 0px 0 30px;
      .blogTitle {
        font-size: 32px;
        margin-bottom: 25px;
        /*font-weight: bold;*/
      }
      .blogUpTime {
        position: absolute;
        top: 10px;
        right: 0;
        color: #555;
      }
      .blogIntro {
        margin-bottom: 16px;
      }
      .blogDetail {
        color: #2479CC;
        cursor: pointer;
      }
    }
    .pageCon{
      text-align: center;
      margin: 30px 0;
      .number:hover{
      }
      .active{
        background-color: #606566!important;
      }
      input[type='number']:focus{
        border-color: #606566!important;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .main {
      .blogUpTime {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue